import { UUID_REGEX } from "@bindery/shared/auth/authConstants";
import { EarlyExitReason } from "@bindery/shared/contracts/study";
import * as z from "zod";
import { ORIENTATION_API_PREFIX } from "./errors";

export const EARLY_EXIT_PATH = `${ORIENTATION_API_PREFIX}/early-exit`;

export const earlyExitRequestSchema = z.strictObject({
  sessionId: z.string().regex(UUID_REGEX),
  reason: z.enum(EarlyExitReason),
});
export type EarlyExitRequest = z.infer<typeof earlyExitRequestSchema>;

// `withdrawalPending` is true when a parent's withdrawal could not reach
// every system that holds the child's data, so staff must finish it.
export const earlyExitResponseSchema = z.object({
  alreadyExited: z.boolean(),
  withdrawalPending: z.boolean(),
});
export type EarlyExitResponse = z.infer<typeof earlyExitResponseSchema>;
